// The GymRite icon set: Eva icons, imported one by one so they are bundled with the app
// (no runtime requests to the Iconify API) and only the icons used are shipped.
// Use them through <GrIcon icon={icons.xxx} />. To add an icon: import it here first, then use it.
import pieChartOutline from "@iconify/icons-eva/pie-chart-outline";
import messageCircleOutline from "@iconify/icons-eva/message-circle-outline";
import infoOutline from "@iconify/icons-eva/info-outline";
import fileTextOutline from "@iconify/icons-eva/file-text-outline";
import filmOutline from "@iconify/icons-eva/film-outline";
import activityOutline from "@iconify/icons-eva/activity-outline";
import calendarOutline from "@iconify/icons-eva/calendar-outline";
import mapOutline from "@iconify/icons-eva/map-outline";
import peopleOutline from "@iconify/icons-eva/people-outline";
import playCircleOutline from "@iconify/icons-eva/play-circle-outline";
import clockOutline from "@iconify/icons-eva/clock-outline";
import headphonesOutline from "@iconify/icons-eva/headphones-outline";
import bellOutline from "@iconify/icons-eva/bell-outline";
import menu2Fill from "@iconify/icons-eva/menu-2-fill";
import moreVerticalFill from "@iconify/icons-eva/more-vertical-fill";
import plusFill from "@iconify/icons-eva/plus-fill";
import minusFill from "@iconify/icons-eva/minus-fill";
import arrowForwardFill from "@iconify/icons-eva/arrow-forward-fill";
import chevronDownFill from "@iconify/icons-eva/chevron-down-fill";
import downloadOutline from "@iconify/icons-eva/download-outline";
import cloudUploadOutline from "@iconify/icons-eva/cloud-upload-outline";
import logOutOutline from "@iconify/icons-eva/log-out-outline";
import refreshOutline from "@iconify/icons-eva/refresh-outline";
import shoppingCartOutline from "@iconify/icons-eva/shopping-cart-outline";
import checkmarkOutline from "@iconify/icons-eva/checkmark-outline";
import alertTriangleOutline from "@iconify/icons-eva/alert-triangle-outline";
import trendingDownOutline from "@iconify/icons-eva/trending-down-outline";
import flagOutline from "@iconify/icons-eva/flag-outline";
import dropletOutline from "@iconify/icons-eva/droplet-outline";
import smilingFaceOutline from "@iconify/icons-eva/smiling-face-outline";
import outlineMonitorWeight from "@iconify/icons-ic/outline-monitor-weight";
import searchOutline from "@iconify/icons-eva/search-outline";
import funnelOutline from "@iconify/icons-eva/funnel-outline";
import closeOutline from "@iconify/icons-eva/close-outline";
import doneAllOutline from "@iconify/icons-eva/done-all-outline";
import personOutline from "@iconify/icons-eva/person-outline";
import personAddOutline from "@iconify/icons-eva/person-add-outline";
import personRemoveOutline from "@iconify/icons-eva/person-remove-outline";
import lockOutline from "@iconify/icons-eva/lock-outline";
import cameraOutline from "@iconify/icons-eva/camera-outline";
import micOutline from "@iconify/icons-eva/mic-outline";
import heartOutline from "@iconify/icons-eva/heart-outline";
import awardOutline from "@iconify/icons-eva/award-outline";
import flashOutline from "@iconify/icons-eva/flash-outline";
import eyeOutline from "@iconify/icons-eva/eye-outline";
import eyeOffOutline from "@iconify/icons-eva/eye-off-outline";

import chevronRightFill from "@iconify/icons-eva/chevron-right-fill";
import chevronLeftFill from "@iconify/icons-eva/chevron-left-fill";
import arrowBackOutline from "@iconify/icons-eva/arrow-back-outline";
// Chat (messages page): send, attach image, edit, link, formatting.
import paperPlaneOutline from "@iconify/icons-eva/paper-plane-outline";
import imageOutline from "@iconify/icons-eva/image-outline";
import edit2Outline from "@iconify/icons-eva/edit-2-outline";
import trash2Outline from "@iconify/icons-eva/trash-2-outline";
import link2Outline from "@iconify/icons-eva/link-2-outline";
import externalLinkOutline from "@iconify/icons-eva/external-link-outline";
import heartFill from "@iconify/icons-eva/heart-fill";
import globeOutline from "@iconify/icons-eva/globe-2-outline";
import chevronUpFill from "@iconify/icons-eva/chevron-up-fill";
import checkmarkCircle2Fill from "@iconify/icons-eva/checkmark-circle-2-fill";
import radioButtonOffOutline from "@iconify/icons-eva/radio-button-off-outline";
import formatBold from "@iconify/icons-ic/outline-format-bold";
import formatItalic from "@iconify/icons-ic/outline-format-italic";
import textFormat from "@iconify/icons-ic/outline-text-format";
// Task types (DAP): Eva has no dumbbell / food / meditation icons, so these come from Material (ic), one file each.
import fitnessCenter from "@iconify/icons-ic/outline-fitness-center";
import restaurant from "@iconify/icons-ic/outline-restaurant";
import selfImprovement from "@iconify/icons-ic/outline-self-improvement";
import menuBook from "@iconify/icons-ic/outline-menu-book";
// Journey cards: a route (two stops and the path between them); Eva has none.
import outlineRoute from "@iconify/icons-ic/outline-route";
import playCircleIc from "@iconify/icons-ic/outline-play-circle-outline";
import roundPlayArrow from "@iconify/icons-ic/round-play-arrow";
import chatBubble from "@iconify/icons-ic/outline-chat-bubble-outline";
// Login app strip ("Mobile app coming soon"): a phone and the two platform marks, decorative only.
import outlineSmartphone from "@iconify/icons-ic/outline-smartphone";
import baselineApple from "@iconify/icons-ic/baseline-apple";

// Delete as before (ant-design two-tone trash), imported as one file.
import deleteTwotone from "@iconify/icons-ant-design/delete-twotone";
const icons = {
  dashboard: pieChartOutline,
  chat: messageCircleOutline,
  info: infoOutline,
  file: fileTextOutline,
  video: filmOutline,
  activity: activityOutline,
  calendar: calendarOutline,
  journey: mapOutline,
  route: outlineRoute,
  people: peopleOutline,
  play: playCircleOutline,
  playArrow: roundPlayArrow,
  clock: clockOutline,
  support: headphonesOutline,
  bell: bellOutline,
  menu: menu2Fill,
  more: moreVerticalFill,
  plus: plusFill,
  minus: minusFill,
  arrowForward: arrowForwardFill,
  chevronDown: chevronDownFill,
  download: downloadOutline,
  upload: cloudUploadOutline,
  logOut: logOutOutline,
  refresh: refreshOutline,
  cart: shoppingCartOutline,
  check: checkmarkOutline,
  alert: alertTriangleOutline,
  trendDown: trendingDownOutline,
  flag: flagOutline,
  droplet: dropletOutline,
  smile: smilingFaceOutline,
  weight: outlineMonitorWeight,
  search: searchOutline,
  filter: funnelOutline,
  close: closeOutline,
  doneAll: doneAllOutline,
  person: personOutline,
  personAdd: personAddOutline,
  personRemove: personRemoveOutline,
  lock: lockOutline,
  camera: cameraOutline,
  mic: micOutline,
  heart: heartOutline,
  award: awardOutline,
  energy: flashOutline,
  eye: eyeOutline,
  eyeOff: eyeOffOutline,
  chevronRight: chevronRightFill,
  chevronLeft: chevronLeftFill,
  deleteTwoTone: deleteTwotone,
  arrowBack: arrowBackOutline,
  taskWorkout: fitnessCenter,
  taskMeal: restaurant,
  taskMindset: selfImprovement,
  taskWorkbook: menuBook,
  taskVideo: playCircleIc,
  taskComment: chatBubble,
  send: paperPlaneOutline,
  image: imageOutline,
  edit: edit2Outline,
  trash: trash2Outline,
  link: link2Outline,
  // Opens in a new tab (e.g. the booking page button).
  external: externalLinkOutline,
  // Community feed: liked heart, the General Community (everyone) mark.
  heartFilled: heartFill,
  globe: globeOutline,
  chevronUp: chevronUpFill,
  // Status marks in lists (check-in done / not done).
  checkCircle: checkmarkCircle2Fill,
  circle: radioButtonOffOutline,
  formatBold,
  formatItalic,
  textFormat,
  smartphone: outlineSmartphone,
  apple: baselineApple,
};

export default icons;
